/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Need_To_PayInputs */

const vi_customer_need_to_pay = /** @type {(inputs: Customer_Need_To_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách cần trả`)
};

/**

* @param {Customer_Need_To_PayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_need_to_pay = /** @type {((inputs?: Customer_Need_To_PayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Need_To_PayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_need_to_pay(inputs)
});